import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";

const TriviaLevelUpModal = ({ open, newLevel, onClose, reducedMotion }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box sx={{ textAlign: "center", py: 3 }}>
          <motion.div
            initial={reducedMotion ? false : { scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={reducedMotion ? { duration: 0 } : { type: "spring" }}
          >
            <Typography variant="h3" fontWeight={800} color="primary.main">
              Level Up!
            </Typography>
            <Typography variant="h4" sx={{ mt: 2 }}>
              Level {newLevel}
            </Typography>
          </motion.div>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TriviaLevelUpModal;
